<div class="grid grid-cols-2 gap-x-6">
	<div class="flex flex-col gap-6">
		<ui-section title="General Details">
			<div section-content class="space-y-6">
				<ui-info-row infoLabel="Closing Date">
					<app-sale-closing-date
						class="flex-1"
						label=""
					></app-sale-closing-date>
				</ui-info-row>
				<ui-info-row
					infoLabel="Loan Reference #"
					[infoValue]="mortgage?.data?.lenderReferenceNumber"
				></ui-info-row>
				<ui-info-row infoLabel="Standard Charge Term #">
					<app-input
						class="flex-1"
						label=""
						[ngModel]="matterMortgage?.standardChargeTerm"
						(debounce)="setStandardChargeTerm($event)"
					></app-input>
				</ui-info-row>
				<ui-info-row
					infoLabel="Deal ID"
					[infoValue]="mortgage?.overview?.transactionId"
				></ui-info-row>
				<div class="mt-10" *ngIf="mortgage?.data?.solicitorConditions">
					<h4 class="mb-2">Solicitor conditions</h4>
					<div class="flex flex-col">
						<span
							*ngFor="let condition of mortgage?.data?.solicitorConditions"
							>{{ condition.clause }}</span
						>
					</div>
				</div>
				<ui-info-row
					infoLabel="Lender Comments"
					[infoValue]="mortgage?.data?.lenderComments"
				></ui-info-row>
				<ui-info-row infoLabel="Priority">
					<span class="text-gray-500">{{
						(matterMortgage?.priority | ordinalSuffix) + ' Priority'
					}}</span>
				</ui-info-row>
			</div>
		</ui-section>

		<app-llc-lender-details
			[mortgage]="mortgage"
			[matterMortgage]="matterMortgage"
		></app-llc-lender-details>
	</div>

	<div class="flex flex-col gap-6">
		<app-mortgage-broker [mortgage]="matterMortgage"></app-mortgage-broker>

		<app-mortgage-guarantors
			[allowAddEdit]="true"
			[matterMortgageId]="matterMortgage?.id"
		></app-mortgage-guarantors>
	</div>
</div>
